export default __webpack_public_path__ + "static/media/cs_text_white.8f44a7b1.svg";